import { useCallback, useMemo, useState } from 'react'

interface IUseIsCompletedOutput {
  isCompleted: boolean
  onSubmit: (args: unknown) => void
}

type onSubmitInput = ((args: any) => void) | ((args: any) => Promise<void>)

export const useCompleteOnSubmit = (onSubmit: onSubmitInput): IUseIsCompletedOutput => {
  const [isCompleted, setIsCompleted] = useState(false)

  const wrappedOnSubmit = useCallback(
    (args: unknown) => {
      onSubmit(args)
      setIsCompleted(true)
    },
    [onSubmit, setIsCompleted]
  )

  return useMemo(() => ({ isCompleted, onSubmit: wrappedOnSubmit }), [isCompleted, wrappedOnSubmit])
}
